import React from 'react';
import './SplashScreen.css';

const SplashScreen = () => {
    return (
        <div className="splash-screen">
            <div className="splash-content">
                <img
                    src="/etpos-logo.png"
                    alt="etPOS"
                    className="splash-logo"
                />
                <div className="splash-loader">
                    <div className="spinner"></div>
                </div>
            </div>
        </div>
    );
};

export default SplashScreen;
